import React, { lazy, Suspense } from 'react';
import SuspenseLoader from './components/Loader/Suspense';
import Layout from './layout';
import PrivateRoutes from './middleware/Authentification/PrivateRoutes';

const Loader = (Component: React.FC) => (props: any) => (
  <Suspense fallback={<SuspenseLoader />}>
    <Component {...props} />
  </Suspense>
);

const HomePage = Loader(lazy(() => import('./pages/Home')));
const MyProductsPage = Loader(lazy(() => import('./pages/MyProducts')));
const CreateProductMultiPage = Loader(
  lazy(() => import('./pages/CreateProductMulti'))
);

const LoginPage = Loader(lazy(() => import('./pages/Login')));
const LoginShopifyPage = Loader(lazy(() => import('./pages/LoginShopify')));
const Register = Loader(lazy(() => import('./pages/Register')));
const Integration = Loader(lazy(() => import('./pages/Integration')));
const ShopifyOnBoard = Loader(lazy(() => import('./pages/ShopifyOnBoard')));
const PrintifyOnBoard = Loader(lazy(() => import('./pages/PrintifyOnBoard')));

const UserOnBoard = Loader(lazy(() => import('./pages/UserOnBoard')));
const Status404 = Loader(lazy(() => import('./pages/Helpful/Error/404')));
const ComingSoon = Loader(lazy(() => import('./pages/Helpful/ComingSoon')));
const GenerateMockup = Loader(lazy(() => import('./pages/GenerateMockup')));
const CreateShopifyStore = Loader(
  lazy(() => import('./pages/CreateShopifyStore/index'))
);
const ProfilePage = Loader(lazy(() => import('./pages/Profile')));
const PlatformLearning = Loader(lazy(() => import('./pages/PlatformLearning')));
const PackagesPage = Loader(lazy(() => import('./pages/Packages')));
const ContactUs = Loader(lazy(() => import('./pages/ContactUs')));
const Consultation = Loader(lazy(() => import('./pages/Consultation')));
const MyContent = Loader(lazy(() => import('./pages/MyContent')));
const LearningHub = Loader(lazy(() => import('./pages/LearningHub')));
const Onboarding = Loader(lazy(() => import('./pages/OnboardingInitial')));
const DropshippingHome = Loader(lazy(() => import('./pages/DropshippingHome')));
const LogoEditor = Loader(lazy(() => import('./pages/Editor')));
const OnboardingPOD = Loader(
  lazy(() => import('./pages/OnboardingInitial/POD'))
);
const OnboardingBranded = Loader(
  lazy(() => import('./pages/OnboardingInitial/Branded'))
);
const OnboardingDropshipping = Loader(
  lazy(() => import('./pages/OnboardingInitial/Dropshipping'))
);
const DropshoppingOrdersPage = Loader(
  lazy(() => import('./pages/DropshippingHome/pages/Orders'))
);

const DropshippingProductDetailsPage = Loader(
  lazy(() => import('./pages/DropshippingHome/pages/ProductDetails'))
);
const CJDropshipping = Loader(lazy(() => import('./pages/CJDropshipping')));

const comingSoonPages = ['/mockups', '/trending', '/content'];

const routes = () => [
  {
    element: <PrivateRoutes />,
    children: [
      {
        element: <Layout />,
        children: [
          {
            path: '/packages',
            element: <PackagesPage />,
          },
          // {
          //   path: "/content",
          //   element: <MyContent />,
          // },
          {
            path: '/profile',
            element: <ProfilePage />,
          },
          {
            path: '/',
            element: <HomePage />,
          },
          {
            path: '/editor',
            element: <LogoEditor />,
          },
          {
            path: '/orders',
            element: <DropshippingHome />,
            children: [
              {
                index: true,
                element: <DropshoppingOrdersPage />,
              },
              {
                path: ':productID',
                element: <DropshippingProductDetailsPage />,
              },
            ],
          },
          {
            path: '/dropshipping/orders',
            element: <DropshippingHome />,
          },

          {
            path: '/pod/create',
            element: <CreateProductMultiPage />,
          },
          {
            path: '/branded/create',
            element: <CreateProductMultiPage />,
          },
          {
            path: '/dropshipping/create',
            element: <CJDropshipping />,
          },
          {
            path: '/myProducts',
            element: <MyProductsPage />,
          },
          {
            path: '/integration',
            element: <Integration />,
          },
          {
            path: '/tutorials',
            element: <PlatformLearning />,
          },
          {
            path: '/onboarding',
            element: <Onboarding />,
            children: [
              {
                path: 'pod',
                element: <OnboardingPOD />,
              },
              {
                path: 'dropshipping',
                element: <OnboardingDropshipping />,
              },
              {
                path: 'branded',
                element: <OnboardingBranded />,
              },
            ],
          },
          // {
          //   path: "/shopifyOnBoard",
          //   element: <ShopifyOnBoard />,
          // },
          // {
          //   path: "/printifyOnBoard",
          //   element: <PrintifyOnBoard />,
          // },
          {
            path: '/storeBuilder',
            element: <CreateShopifyStore />,
          },
          {
            path: '/learningHub',
            element: <LearningHub />,
          },
          {
            path: '/contactUs',
            element: <ContactUs />,
          },
          {
            path: '/consultation',
            element: <Consultation />,
          },
          {
            path: '*',
            element: comingSoonPages.includes(window.location.pathname) ? (
              <ComingSoon />
            ) : (
              <Status404 />
            ),
          },
        ],
      },
    ],
  },

  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/shopify/callback',
    element: <LoginShopifyPage />,
  },
  {
    path: '/register',
    element: <Register />,
  },
];

export default routes;
